// Stany widoku (S-6, S-8, S-9): spinner, ładowanie, pusto, błąd - w karcie sekcji.
import type { ReactNode } from "react";
import { IconInbox, IconAlertCircle } from "./icons";

export function Spinner({ size = "m" }: { size?: "s" | "m" | "l" }) {
  return <span className={`spinner spinner--${size}`} aria-hidden="true" />;
}

export function LoadingState({ text = "Ładowanie danych..." }: { text?: string }) {
  return (
    <div className="state-block">
      <div className="state-block__spinner-wrap">
        <Spinner size="l" />
        <p className="state-block__loading-text">{text}</p>
      </div>
    </div>
  );
}

export function EmptyState({
  title,
  desc,
  icon,
  action,
}: {
  title: string;
  desc?: string;
  icon?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="state-block">
      <div className="state-block__icon" aria-hidden="true">
        {icon ?? <IconInbox size={22} />}
      </div>
      <h3 className="state-block__title">{title}</h3>
      {desc ? <p className="state-block__desc">{desc}</p> : null}
      {action}
    </div>
  );
}

export function ErrorState({
  title = "Nie udało się pobrać danych",
  desc = "Sprawdź połączenie i spróbuj ponownie. Jeśli problem wraca, skontaktuj się z nami.",
  detail,
  onRetry,
  retryLabel = "Spróbuj ponownie",
}: {
  title?: string;
  desc?: string;
  detail?: string;
  onRetry?: () => void;
  retryLabel?: string;
}) {
  return (
    <div className="state-block">
      <div className="state-block__icon state-block__icon--danger" aria-hidden="true">
        <IconAlertCircle size={22} />
      </div>
      <h3 className="state-block__title">{title}</h3>
      <p className="state-block__desc">{desc}</p>
      {onRetry ? (
        <button type="button" className="btn-secondary" onClick={onRetry}>
          {retryLabel}
        </button>
      ) : null}
      {detail ? <p className="state-block__detail">{detail}</p> : null}
    </div>
  );
}
